import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    langMap: [
      {
        langCode: "en",
        name: "",
        category: "",
        overview: "",
      },
    ],
    profileImage: "",
    cropFamilies: [],
  },
};

export const postPestPreviewInfoSlice = createSlice({
  name: "postPestPreviewInfo",
  initialState,
  reducers: {
    replaceIndex: (state, action) => {
      const { index, data } = action.payload;
      if (state.value.langMap[index]) {
        state.value.langMap[index] = data;
      }
    },
    addNewLangData: (state, action) => {
      const existingIndex = state.value.langMap.findIndex(
        (item) => item.langCode === action.payload.langCode
      );
      if (existingIndex !== -1) {
        state.value.langMap[existingIndex] = action.payload;
      } else {
        state.value.langMap.push(action.payload);
      }
    },
    updateProfileImage: (state, action) => {
      state.value.profileImage = action.payload;
    },
    updateCropFamilies: (state, action) => {
      state.value.cropFamilies = action.payload;
    },
    resetState: (state) => {
      state.value = initialState.value;
    },
  },
});

export const {
  replaceIndex,
  addNewLangData,
  updateProfileImage,
  updateCropFamilies,
  resetState,
} = postPestPreviewInfoSlice.actions;

export default postPestPreviewInfoSlice.reducer;
